import { apiClient } from "./apiClient";

export interface LimpezaDiariaLogItem {
  id: number;
  execucaoEm: string;
  referenciaDia: string;
  categoria: string;
  lojaId: number | null;
  lojaNome: string | null;
  entidadeOrigemId: number;
  resumo: string;
  payload: unknown;
}

export interface LimpezaDiariaLogResponse {
  itens: LimpezaDiariaLogItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const LIMPEZA_DIARIA_CATEGORIA_LABELS: Record<string, string> = {
  fila_aguardando_entrega: "Fila aguardando entrega",
  forno: "Forno",
  montagem: "Montagem",
  entrega: "Entrega",
  producao: "Produção (forno)",
  borda_em_falta: "Borda em falta",
  borda_preparo_diario: "Preparo de borda",
  fila_entrega: "Fila de entregador",
};

export async function fetchLimpezaDiariaLogs(params: {
  dataInicio?: string;
  dataFim?: string;
  lojaId?: number | null;
  categoria?: string;
  page?: number;
  limit?: number;
}): Promise<LimpezaDiariaLogResponse> {
  const qs = new URLSearchParams();
  if (params.dataInicio) qs.set("dataInicio", params.dataInicio);
  if (params.dataFim) qs.set("dataFim", params.dataFim);
  if (params.lojaId != null && params.lojaId > 0) {
    qs.set("lojaId", String(params.lojaId));
  }
  if (params.categoria) qs.set("categoria", params.categoria);
  if (params.page != null) qs.set("page", String(params.page));
  if (params.limit != null) qs.set("limit", String(params.limit));
  return apiClient.get(`/limpeza-diaria/logs?${qs.toString()}`);
}
